import React from 'react';
import styled from '@emotion/styled/macro';
import Translate from '@utils/translation-functions';
import vars from '@variables';
import { getTagColour } from '@utils/utils';
import { TileTagsProps } from './tile.types';
import { useLocale } from '@hooks/useLocale';

const searchUrlMap = new Map([
  ['es', '/es/explora'],
  ['pt', '/pt/saiba-mais'],
]);

const TileTags: React.FC<TileTagsProps> = ({
  tags,
  tagLimit = 3,
  translate = true,
  className,
}) => {
  const locale = useLocale();
  const searchUrl = searchUrlMap.get(locale) || '/explore';

  return (
    <TileTagsContainer className={className}>
      {tags &&
        tags.length > 0 &&
        tags.slice(0, tagLimit).map((tag, index) => {
          if (typeof tag !== 'object') {
            console.error(
              `Error in tile-tags.js -> TileTags. Type of tag != object. Failing tag: ${tag}`
            );
            return null;
          }

          const title = Translate(tag.title, translate);

          // converts title to PascalCase for search query
          const titleQuery = tag.title
            .split(' ')
            .map(
              word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
            )
            .join('');
          const color = getTagColour(tag);

          return (
            <TileTag key={`${tag.title}-tag-${index}`} color={color}>
              <a href={`${searchUrl}?sortBy=dateDesc&topics=${titleQuery}`}>
                {title}
              </a>
              <TagUnderline color={color} />
            </TileTag>
          );
        })}
    </TileTagsContainer>
  );
};

export const TileTagsContainer = styled.ul`
  display: flex;
  gap: ${vars.spacingS};

  a {
    width: fit-content !important;
  }
`;
export default TileTags;

interface TagProps {
  color: string;
}

const TagUnderline = styled.span<TagProps>`
  width: 100%;
  height: 2px;
  background-color: ${props => props.color};
  opacity: 0;
`;

const TileTag = styled.li<TagProps>`
  list-style: none;
  position: relative;

  a {
    color: ${vars.coreDarkGrey};
    margin-bottom: ${vars.spacingXs};
    font-size: ${vars.fontSize1};
  }
  :hover {
    a {
      color: ${props => props.color};
    }

    ${TagUnderline} {
      position: absolute;
      bottom: 0;
      opacity: 1;
      transition: ${vars.defaultTransition};
    }

    cursor: pointer;
  }
`;
